module.exports = __webpack_public_path__ + "media/images/landing_side_bookshops-462fcaa044c4231dd35f1e8bf93a1c36.jpg";